import type { ComponentProps } from "react";

type SvgProps = ComponentProps<"svg">;

const EventTopicTalk = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.71307 3.48415L9.60807 6.79267C10.2129 7.48387 10.2129 8.51607 9.60807 9.2072L6.71313 12.5157C5.98268 13.3505 4.68407 13.3505 3.95365 12.5157L1.05868 9.2072C0.453859 8.51607 0.453856 7.48387 1.05867 6.79267L3.95365 3.48415C4.68407 2.64938 5.98267 2.64938 6.71307 3.48415Z"
      fill="currentColor"
    />
    <path
      d="M8.66667 12.6667L11.9229 8.86773C12.3509 8.3684 12.3509 7.6316 11.9229 7.13227L8.66667 3.33333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3333 12.6667L14.5896 8.86773C15.0175 8.3684 15.0175 7.6316 14.5896 7.13227L11.3333 3.33333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EventTopicTalk;
